import { alpha } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { BLOCK_ITEM_HEIGHT } from '../styles';
import { BlockItemFormat } from '../';

export const useStyles = makeStyles((theme) => ({
  brandkey: {
    backgroundColor: alpha(theme.palette.grey[800], 0.7),
    borderRadius: 2,
    color: 'white',
    left: theme.spacing(1),
    padding: theme.spacing(0, 0.5),
    position: 'absolute',
    top: theme.spacing(1),
    zIndex: 1,
  },
  imageFallback: {
    color: theme.palette.grey[300],
    fontSize: '4rem',
  },
  media: ({ blockItemFormat }: { blockItemFormat: BlockItemFormat }) => ({
    backgroundColor: theme.palette.grey[200],
    flexBasis: 160,
    flexShrink: 0,
    flexGrow: 1,
    height:
      blockItemFormat === BlockItemFormat.CONDENSED
        ? BLOCK_ITEM_HEIGHT + 2
        : 200 + 2,

    ...(blockItemFormat !== BlockItemFormat.CONDENSED && {
      borderTopLeftRadius: 3,
      borderTopRightRadius: 3,
      overflow: 'hidden',
      width: '100%',
    }),
  }),
}));
